// extracted by mini-css-extract-plugin
module.exports = {"finalRow":"CoreTable_finalRow__nbFGe","addRow":"CoreTable_addRow__W1lkr"};